import { TextField, Stack } from "@mui/material"
import { useState } from "react";
import SecurityIcon from '@mui/icons-material/Security';
import { LoadingButton } from "@mui/lab";

export default function Pin({onSubmit, loading, error}){

    const [pin, setPin] = useState('')

    const handleSubmit = e => {
        e.preventDefault();
        return onSubmit(pin);
    }

    return <form onSubmit={handleSubmit}>

        <Stack direction='column' spacing={3}>

            <h1>Vérification requise</h1>

            <p>Veuillez entrer votre code de vérification pour accéder à la ressource.</p>

            <TextField
                label="Code de vérification à 6 chiffres"
                value={pin}
                onChange={e => setPin(e.target.value)}
                error={error}
                helperText={error && "Code invalide"}
                required
                InputProps={{
                    inputProps: {
                        minLength: 6,
                        maxLength: 6,
                        pattern: "[0-9]{6}"
                    },
                    endAdornment: <SecurityIcon color='action'/>
                }}
                size='small'
            />

            <LoadingButton
                type='submit'
                variant='contained'
                loading={loading}
                sx={{alignSelf: 'end'}}
            >
                Valider
            </LoadingButton>

        </Stack>

    </form>
}